// first time action types
export const SHOW_COLLECTIONS_NOTIFICATION_BOX = 'SHOW_COLLECTIONS_NOTIFICATION_BOX';
// storage name
export const FIRST_TIME_ACTION_STORAGE_NAME = 'discovery-firstTimeActions';
export const FIRST_TIME_ACTION_STORAGE_EXPIRE_PERIOD_DAYS = 365;
// action creator types
export const LOAD_FIRST_TIME_ACTIONS = 'LOAD_FIRST_TIME_ACTIONS';
